import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

interface DuplicateBody {
  destinationFolderId: number;
  lastUpdated?: number;
}

interface DuplicateConfig extends AxiosRequestConfig {
  body: DuplicateBody;
  data: DuplicateBody;
  method: 'POST';
  url: `/exercises/${string}`;
}

/**
 * POST /v1/exercises/{exerciseId}
 *
 * { 
 * destinationFolderId: number,
 * lastUpdated: number
 * }
 */
export const duplicateExercise = (
  exerciseId: string,
  destinationFolderId: number,
  lastUpdated: number,
): DuplicateConfig => {
  const data = { destinationFolderId, lastUpdated };

  return {
    baseURL: BASE_API,
    method: 'POST',
    url: `/exercises/${exerciseId}`,
    body: data,
    data,
  };
};

interface DuplicateFolderConfig extends AxiosRequestConfig {
  body: DuplicateBody;
  data: DuplicateBody;
  method: 'POST';
  url: `/assignment-folders/${number}`;
}

/**
 * POST /v1/assignment-folders/{sourceFolderId}
 *
 * { destinationFolderId: number }
 */
export const duplicateFolder = (
  sourceFolderId: number,
  destinationFolderId: number,
): DuplicateFolderConfig => {
  const data = { destinationFolderId };

  return {
    baseURL: BASE_API,
    method: 'POST',
    url: `/assignment-folders/${sourceFolderId}`,
    body: data,
    data,
  };
};
